import React, { useState, useEffect } from 'react';
import { Container } from '@mui/material';
import { SearchComponent } from './search';
import PropTypes from 'prop-types';

export const HeaderLayoutBottomComponent = ({ keyword, searchGooglePlaces, searchMobile, user }) => {
    const [showTaskInsuranceBanner, setShowTaskInsuranceBanner] = useState(false);
    const [bannerType, setBannerType] = useState(null); // 'merchant' or 'consumer'

    const merchantBannerPages = [
        '/merchants/upload',
        '/merchants/dashboard',
        '/merchants/quotation/list',
        '/merchants/order/history',
        '/merchants/items',
        '/pages/provide-a-task'
    ];

    const consumerBannerPages = ['/', '/pages/about'];

    useEffect(() => {
        const pathname = window.location.pathname;
        const isMerchant = user?.Roles?.includes('Merchant') || user?.Roles?.includes('Submerchant');

        if (merchantBannerPages.includes(pathname)) {
            setShowTaskInsuranceBanner(true);
            setBannerType('merchant');
        } else if (pathname === '/chat/inbox' && isMerchant) {
            setShowTaskInsuranceBanner(true);
            setBannerType('merchant');
        } else if (consumerBannerPages.includes(pathname)) {
            setShowTaskInsuranceBanner(true);
            setBannerType('consumer');
        }
    }, []);

    return (
        <div className='header-bottom'>
            {showTaskInsuranceBanner && (
                <div className="task-insurance-banner">
                    <div className="task-insurance-banner-content">
                        {bannerType === 'merchant' ? (
                            <p>
                                Your Tasker Subscription now includes Tasker Insurance on eligible tasks. Terms and conditions apply.*{' '}
                                <a href="https://task.marketplace.bcaa.com/pages/tasker-insurance" target='_blank'><u>Learn More</u></a>
                            </p>
                        ) : (
                            <p>
                                All Taskers have Tasker Insurance on eligible tasks. Terms and conditions apply.*{' '}
                                <a href="https://task.marketplace.bcaa.com/pages/tasker-insurance" target='_blank'><u>Learn More</u></a>
                            </p>
                        )}
                    </div>
                    <button
                        className="task-insurance-banner-close"
                        aria-label="Close task insurance banner"
                        onClick={() => setShowTaskInsuranceBanner(false)}
                    >
                        &times;
                    </button>
                </div>
            )}
            <Container maxWidth='xl' sx={{ desktop: { px: '40px' } }}>
                <ul className='header-menus'>
                    <li className='h-search'>
                        <SearchComponent keyword={keyword} searchGooglePlaces={searchGooglePlaces} />
                    </li>
                    <li className='h-mobi-search mobi-show' onClick={searchMobile}>
                        <i className='fa fa-search !tw-text-[#0050c4]'></i>
                    </li>
                </ul>
            </Container>
        </div>
    );
};

HeaderLayoutBottomComponent.propTypes = {
    keyword: PropTypes.string,
    searchGooglePlaces: PropTypes.func,
    searchMobile: PropTypes.func.isRequired,
    user: PropTypes.object
};
